import { useState } from 'react';
import toast from 'react-hot-toast';
import '../styles/components/ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: '',
  });

  const [submissionStatus, setSubmissionStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   
    setIsSubmitting(true);
    setSubmissionStatus('');

        toast.success('Message sent successfully! We will get back to you soon.');
        setSubmissionStatus('Message sent successfully! We will get back to you soon.');

        // Reset form
        setFormData({
          name: '',
          email: '',
          organization: '',
          message: '',
        });
     setTimeout(() => {
      setIsSubmitting(false);
      setSubmissionStatus('');
     }, 2000);
  };

  return (
    <section id="contact-section" className="contact-section">
      <div className="container">
        <h2>Contact Our Travel Experts | Free Flight Booking Consultation</h2>
        <p>Get personalized travel advice and exclusive flight deals from our certified travel consultants. Contact us for group bookings, corporate travel, or custom itinerary planning.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="organization"
            placeholder="Travel Destination/Group Size"
            value={formData.organization}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          {submissionStatus && <p className="success-message">{submissionStatus}</p>}
          <button
            type="submit"
            className="contact-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
